import styled from 'styled-components';
import CheggSVG from '../primitives/svg';
import { sceneIllustrationIconSizeToPixelValue, sceneIllustrationIconSizeToRemValue } from '../shared';

/**
 * Base SceneIllustrationSvgIcon component
 *
 * Sized using `rem` units. Pixel equivalents in param info.
 *
 * Do not set height & width manually; use `size` instead.
 *
 * @param props.size small (default): 264px, medium: 376px, large: 544px
 */
export var SceneIllustrationSvgIcon = styled(CheggSVG).attrs(function (props) {
  var pixelValue = sceneIllustrationIconSizeToPixelValue[props.size ||
  /* istanbul ignore next */
  'small'];
  return {
    height: pixelValue,
    width: pixelValue
  };
}).withConfig({
  componentId: "sc-10wu17s-0"
})(["", ""], function (props) {
  var remValue = sceneIllustrationIconSizeToRemValue(props.size ||
  /* istanbul ignore next */
  'small');
  return "\n      height: ".concat(remValue, "rem;\n      width: ").concat(remValue, "rem;\n      // without setting min-values, the icons can shrink below desired size when used in flexbox\n      min-height: ").concat(remValue, "rem;\n      min-width: ").concat(remValue, "rem;\n      box-sizing: border-box;\n      overflow: visible; // this is to fix svg cut issue on zoom\n    ");
});
SceneIllustrationSvgIcon.displayName = 'SceneIllustrationSvgIcon';
SceneIllustrationSvgIcon.defaultProps = {
  size: 'small',
  viewBox: '0 0 544 544'
};
export default SceneIllustrationSvgIcon;